import React, { useCallback, useEffect } from "react";
import ReactDOM from "react-dom";
import CachedImage from "components/CachedImage";
import "./style.scss";

interface Props {
  src: string;
  alt?: string;
  onClose: () => void;
}

function ImageLightbox({ src, alt, onClose }: Props) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [handleKeyDown]);

  const handleBackdropClick = useCallback(
    (e: React.MouseEvent) => {
      if (e.target === e.currentTarget) onClose();
    },
    [onClose]
  );

  return ReactDOM.createPortal(
    <div className="image-lightbox" onClick={handleBackdropClick}>
      <button className="image-lightbox__close" onClick={onClose} type="button">
        &times;
      </button>
      <CachedImage className="image-lightbox__image" src={src} alt={alt || ""} onClick={onClose} />
      {alt && <div className="image-lightbox__filename">{alt}</div>}
    </div>,
    document.body
  );
}

export default ImageLightbox;
